import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

@Component({
    components: {
        AlertBanner
    }
})
export default class LaboratoryTrackingCancellationModalForm extends Vue {
    @Ref() readonly laboratoryTrackingCancellationModalForm!: any
    @Prop() readonly elementsNumber!: number

    show() {
        this.laboratoryTrackingCancellationModalForm.show()
    }

    hide() {
        this.laboratoryTrackingCancellationModalForm.hide()
    }
}
